import { useState, useRef, useEffect } from "react";

import logo from "../images/logo.png";
import tower from "../images/tower.svg";
import tv from "../images/tv.svg";
import doc from "../images/open-doc.svg";
import { Navigate } from "react-router-dom";
import utility from "./Utils";
import { decryptAES,encryptAES } from "./Decrypt.js";

import {
  NO_USER,
  USER_LOGGED,
  FS_LOADER_FADE_TIME,
  API_BASE,
  TOKEN_ISSUER,
  TOKEN_ALGO,
  SPKI,VKEY,
} from "core/Constants";
import FullPageLoading from "core/FullPageLoading";
import axios from "axios";
import * as jose from "jose";
import { Toaster, toast } from "react-hot-toast";

const delay = 2500;
const slides = [
  {
    title: "Multi format report",
    desc: "Reports can be generated in XLSX, CSV and PDF formats",
  },
  {
    title: "Long availability",
    desc: "You can access your data for long periods of time",
  },
];

const Login = props => {
  const [index, setIndex] = useState(0);
  const [username, setUsername] = useState("");
  const [cpassword, setPassword] = useState("");
  const [femail, setFEmail] = useState("");
  const [user, setUser] = useState(null);
  const [state, setState] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showFPass, setShowFPass] = useState(false);
  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    utility
      .getToken()
      .then(result => {
        setTimeout(() => {
          setState(result ? USER_LOGGED : NO_USER);
        }, FS_LOADER_FADE_TIME);
      })
      .catch(error => {
        console.error(error);
        setState(NO_USER);
      });
  }, []);

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setIndex(prevIndex =>
        prevIndex === slides.length - 1 ? 0 : prevIndex + 1
      );
    }, delay);

    return () => {
      resetTimeout();
    };
  }, [index]);

  //login
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    let user = {};
     //alert("chk"+cpassword+"-"+VKEY);
    let password = await encryptAES(cpassword,VKEY);
    //alert("chk"+password);
    let opts = {
      method: "post",
      url: `${API_BASE}/login`,
      data: { username,password},
    };

    axios(opts)
      .then(async res => {
        const pubKey = await jose.importSPKI(SPKI, TOKEN_ALGO);
        const jwt = res.data.token;
        const refreshToken = res.data.refresh_token; // Assuming the API returns a refresh token

        const { payload } = await jose.jwtVerify(jwt, pubKey, {
          issuer: TOKEN_ISSUER,
        });

        user.name = payload.Name;
        user.token = jwt;
        user.refreshToken = refreshToken; // store the refresh token
        user.type = payload.UserType;
        user.client_type = res.data.client_type;
        user.last_login = res.data.last_login;
        user.client_id = res.data.client_id;
        user.client_name = res.data.client_name;
        user.group_id = res.data.group_id;
       // console.log("permisssion chk before",res.data.permissions);
        let parr = await decryptAES(res.data.permissions,VKEY);
       // console.log("permisssion chk",parr);
        user.permissions = parr;
        user.userwise_subscription = res.data.userwise_subscription;
        user.spots = res.data.spots;
        user.consumed_spots = res.data.consumed_spots;
        user.available_spots = user.spots - user.consumed_spots;
        user.consumption_alert_percent = res.data.consumption_alert_percent;
        await utility.setToken(user);
        await utility.setToken(refreshToken, "refresh"); // Save the refresh token
        setTimeout(() => {
          setUser(user);
          setLoading(false);
        }, 200);
      })
      .catch(error => {
        console.log(error);
        console.error(error);
        toast.error(error.response.data.error);
        setLoading(false);
      });
  };

  //forgot-password
  const handleForgotSubmit = e => {
    e.preventDefault();
    console.log(femail);

    if (femail === "") {
      toast.error("Email is required!");
      return;
    } else if (!/^.+@.+\.[A-Za-z]+$/.test(femail)) {
      toast.error("Invalid Email!");
      return;
    }

    setLoading(true);

    let opts = {
      method: "post",
      url: `${API_BASE}/reset-link`,
      data: { username: femail },
    };

    axios(opts)
      .then(async res => {
        console.log(res);
        if (res.status === 200) {
          toast.success(res.data);
          setFEmail("");
        } else {
          toast.error(res.data);
        }
        setTimeout(() => {
          setLoading(false);
        }, 200);
      })
      .catch(error => {
        console.error(error);
        toast.error(error.response.data.error);
        setLoading(false);
      });
  };

  if (user) {
    return <Navigate to="/dashboard" replace={true} />;
  }

  if (state === 0) {
    return <FullPageLoading />;
  }

  return (
    <div id="login">
      <section className="white">
        <div className="logo">
          <img src={logo} alt="SpotTrek" />
        </div>
        {showFPass ? (
          //forgot password
          <div className="form-wrapper">
            <form onSubmit={handleForgotSubmit}>
              <h2>Forgot Password?</h2>
              <p style={{ lineHeight: "20px" }}>
                Enter your email and we'll send you a link to <br /> reset your
                password.
              </p>

              <div className="row">
                <label>Email*</label>
                <input
                  value={femail}
                  onChange={e => setFEmail(e.target.value)}
                  type="text"
                  placeholder="Enter your email"
                  autoComplete="email"
                />
              </div>
              <div className="row flex flex-center">
                {loading ? (
                  <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                ) : (
                  <button>Submit</button>
                )}
              </div>
              <div className="row">
                <p
                  className="forgotpassword"
                  onClick={() => setShowFPass(false)}
                >
                  &larr;&nbsp;&nbsp;Back to Login
                </p>
              </div>
            </form>
          </div>
        ) : (
          //login
          <div className="form-wrapper">
            <form onSubmit={handleSubmit}>
              <h2>Welcome back!</h2>
              <p>Please enter your login details</p>
              <div className="row">
                <label>Username </label>
                <input
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  type="text"
                  placeholder="Enter your username"
                  autoComplete="email"
                />
              </div>
              <div className="row">
                <label>Password</label>
                <input
                  value={cpassword}
                  onChange={e => setPassword(e.target.value)}
                  type="password"
                  placeholder="Enter your password"
                  autoComplete="current-password"
                />
              </div>
              <div className="row flex flex-center">
                {loading ? (
                  <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                ) : (
                  <button>Login</button>
                )}
              </div>
              <div className="row">
                <p
                  className="forgotpassword"
                  onClick={() => setShowFPass(true)}
                >
                  Forgot password?
                </p>
              </div>
            </form>
          </div>
        )}

        <p className="copy">&copy; BARC India 2025</p>
      </section>
      <section className="blue">
        <div className="img-circle tower">
          <img src={tower} alt="tower" />
        </div>
        <div className="img-circle tv">
          <img src={tv} alt="tv" />
        </div>
        <div className="img-circle doc">
          <img src={doc} alt="doc" />
        </div>
        <div className="slideshow-wrapper">
          <div className="slideshow">
            <div
              className="slideshow-slider"
              style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
            >
              {slides.map((slide, index) => (
                <div className="slide" key={index}>
                  <h3>{slide.title}</h3>
                  <p>{slide.desc}</p>
                </div>
              ))}
            </div>
            <div className="slideshow-dots">
              {slides.map((_, idx) => (
                <div
                  key={idx}
                  className={`slideshow-dot${index === idx ? " active" : ""}`}
                  onClick={() => {
                    setIndex(idx);
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Toaster />
    </div>
  );
};

export default Login;
